import { useIntl } from 'react-intl';

import { useEmotionDetectorContext } from '../EmotionDetectorContextProvider';
import { messages } from '../messages';
import NavigationButton from './components/NavigationButton';
import ProfileMenu from './components/ProfileMenu';
import { Container, Header, HeaderTitle, Logo, LogoLink, Nav } from './styles';

interface EmotionDetectorHeaderProps {
	currentPage: 'home' | 'camera' | 'log';
}

export default function EmotionDetectorHeader({ currentPage }: EmotionDetectorHeaderProps) {
	const { formatMessage } = useIntl();
	const { setActiveScreen } = useEmotionDetectorContext();

	return (
		<Header>
			<Container>
				<LogoLink onClick={() => setActiveScreen('home')}>
					<Logo />
					<HeaderTitle>{formatMessage(messages.headerTitle)}</HeaderTitle>
				</LogoLink>

				<Nav>
					<NavigationButton currentPage={currentPage} />
					<ProfileMenu />
				</Nav>
			</Container>
		</Header>
	);
}
